/**
 * @generated SignedSource<<902f74961a683db7d86c6aed93b88f3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InspectionFieldCard$data = {
  readonly assignedDate: any | null;
  readonly externalId: number | null;
  readonly field: {
    readonly id: string;
    readonly previousId: number | null;
  } | null;
  readonly id: string;
  readonly latestInspection: {
    readonly approvedDate: any | null;
    readonly lastModified: any | null;
    readonly rejectedDate: any | null;
    readonly retryDate: any | null;
  } | null;
  readonly managementPackageSetting: {
    readonly displayNameAlt: string | null;
  } | null;
  readonly member: {
    readonly name: string;
  } | null;
  readonly periodEnd: any | null;
  readonly periodStart: any | null;
  readonly plannedDate: any | null;
  readonly state: InspectionfieldStateEnum | null;
  readonly year: number;
  readonly " $fragmentType": "InspectionFieldCard";
};
export type InspectionFieldCard$key = {
  readonly " $data"?: InspectionFieldCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionFieldCard">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionFieldCard",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionNode",
      "kind": "LinkedField",
      "name": "latestInspection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "retryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "approvedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rejectedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastModified",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ManagementPackageSettingsNode",
      "kind": "LinkedField",
      "name": "managementPackageSetting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayNameAlt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberNode",
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FieldNode",
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previousId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};
})();

(node as any).hash = "2e0f63c3ad5a60b7bfe0631923e72dd7";

export default node;
